module.exports = __webpack_public_path__ + "img/item2.1a9f9253.jpg";